import { render, staticRenderFns } from "./PostingModalNew.vue?vue&type=template&id=05f150e7&scoped=true"
import script from "./PostingModalNew.vue?vue&type=script&lang=ts"
export * from "./PostingModalNew.vue?vue&type=script&lang=ts"
import style0 from "./PostingModalNew.vue?vue&type=style&index=0&id=05f150e7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f150e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f150e7')) {
      api.createRecord('05f150e7', component.options)
    } else {
      api.reload('05f150e7', component.options)
    }
    module.hot.accept("./PostingModalNew.vue?vue&type=template&id=05f150e7&scoped=true", function () {
      api.rerender('05f150e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/postings/PostingModalNew.vue"
export default component.exports